
  import { Component, Prop, Vue } from 'vue-property-decorator';
  import MobileSidebar from './MobileSidebar.vue';
  import PageFooter from './PageFooter.vue';

  @Component({
    components: {
      MobileSidebar,
      PageFooter,
    },
  })
  export default class EternaPage extends Vue {
    @Prop({ default: '' }) readonly title!: string;

    @Prop({ default: '' }) readonly header_title!: string;

    @Prop({ default: '' }) readonly header_date!: string;

    get hasSidebarSlot() {
      return !!this.$scopedSlots.sidebar;
    }
  }
